import { useTranslation } from 'next-i18next';
import { Typography } from '@oresundsbron/bridge-ui';

import {
  AddressLine,
  EmailaddressLine,
  PhonenumberLine,
  WebAddressLine,
} from '.';

export const ContactInfo = ({
  contactInfo,
}: {
  contactInfo: Record<
    | 'address'
    | 'name'
    | 'email'
    | 'phone'
    | 'homepage'
    | 'latitude'
    | 'longitude',
    string | number
  >;
}) => {
  const { t } = useTranslation(['club', 'common'], { nsMode: 'fallback' });

  return (
    <div className="rounded-xl border-2 border-primary-600 ">
      <div className="border-b-2 border-b-primary-100 p-6 pb-3">
        <Typography as="h2" intent="headline" className="!mb-0 !leading-[0]">
          <div className="mb-4 text-[16px] font-semibold uppercase text-primary-700">
            {t('club.contactInformation.contact')}
          </div>
          <br />
          <div className="text-4xl font-semibold leading-tight text-primary-950">
            {contactInfo.name}
          </div>
        </Typography>
      </div>
      <div className="px-6">
        <ul className="flex flex-col">
          {contactInfo?.address?.toString() && (
            <AddressLine address={contactInfo.address?.toString()} />
          )}
          {contactInfo?.homepage?.toString() && (
            <WebAddressLine url={contactInfo.homepage?.toString()} />
          )}
          {contactInfo?.phone?.toString() && (
            <PhonenumberLine phoneNumber={contactInfo?.phone.toString()} />
          )}
          {contactInfo?.email?.toString() && (
            <EmailaddressLine email={contactInfo.email?.toString()} />
          )}
        </ul>
      </div>
    </div>
  );
};
